export enum HabitudeChauffageEnum {
  HABITUDE_CHAUFFAGE_18 = 'HABITUDE_CHAUFFAGE_18',
  HABITUDE_CHAUFFAGE_19 = 'HABITUDE_CHAUFFAGE_19',
  HABITUDE_CHAUFFAGE_20 = 'HABITUDE_CHAUFFAGE_20',
  HABITUDE_CHAUFFAGE_21 = 'HABITUDE_CHAUFFAGE_21',
  HABITUDE_CHAUFFAGE_22 = 'HABITUDE_CHAUFFAGE_22',
  HABITUDE_CHAUFFAGE_23 = 'HABITUDE_CHAUFFAGE_23',
}
